export default {
    mergeProjects: 'Projekte zusammenführen',
    mergeProjectsDescription: 'Hier können Sie Projekte zusammenführen. Bitte beachten Sie, dass das zweite Projekt an das erste angehängt wird. Es wird dann ein neues Projekt erstellt, das die Daten beider Projekte enthält. Das ursprüngliche Projekt bleibt unverändert.',
    start: 'Starten',
    projectsMerged: 'Projekte erfolgreich zusammengeführt',
    mergeFailed: 'Zusammenführung fehlgeschlagen',
    instanceName: 'Instanzname',
    instanceType: 'Instanztyp',
    GoToProject: 'Zum Projekt gehen',
    projectVersion: 'Projektversion',
    versionMismatch: 'Die Versionen der Projekte stimmen nicht überein.',
    versionMismatchSolution: 'Bitte aktualisieren Sie die Projekte auf die gleiche Version, bevor Sie sie zusammenführen. Dies kann durch ein Update der Projekte in vSTAGE erfolgen.',
    versionInvalidSolution: 'Bitte upgraden Sie ihr Projekt auf die Version {version} oder höher um es zu mergen.',
    selectProject: 'Projekt auswählen',
    noProjectSelected: 'Kein Projekt ausgewählt',
    noInstances: 'Keine Instanzen gefunden',
    projectName: 'Projektname',
    newProject: 'Neues Projekt',
    Project1: 'Projekt 1',
    Project2: 'Projekt 2',
    mainProjectDescription: 'Das ist das Master-Projekt. Globale Einstellungen wie die ausgewählte Szene werden von diesem Projekt übernommen.',
    resultProject: 'Resultierendes Projekt',
    accessMissing: 'Sie haben keine Berechtigung für eine oder mehrere Projekte oder Inhalte in diesen Projekten.',
    instanceErrors: 'Sie haben nicht Zugriff auf alle verwendeten Elemente in diesem Projekt.',
    noEditPermission: 'Sie haben keine Berechtigung, dieses Projekt zu bearbeiten.',
    projectIdRequired: 'Projekt-ID erforderlich',
    reStart: 'Ein weiteres Projekt zusammenführen',
}